import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Error404 from '../common/Error404';
import RubbishCollection from '../pages/RubbishCollection';
import WasteCalender from '../pages/WasteCalender';
import { encryptData, getCookie, getItem, setCookie, setItem } from '../utils/utils';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import AccessDenied from '../common/AccessDenied';
import { fetchThemeSettings } from '../redux/slice/themeSlice';
import { accessPortal } from '../redux/slice/accessSlice';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import ContactUs from '../pages/ContactUs';
import CookiesPage from '../pages/CookiesPage';
import AccessibilityPage from '../pages/AccessibilityPage';
import HelpPage from '../pages/HelpPage';
import PrivacyPolicy from '../pages/PrivacyPolicy';

const RouteEntry = (props) => {
  const { fetchThemeSettings, themeSettingsData, accessPortal, accessLoading, accessPortalData, accessError } = props;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const uuidParam = searchParams.get('uuid');
  const langParam = searchParams.get('lang');
  const { i18n, t } = useTranslation();
  const language = getItem('language');

  useEffect(() => {
    if (location?.search?.length > 0) {
      setCookie('uuid', uuidParam);
      const apiData = {
        P_UID: uuidParam,
      };
      const encryptedPayload = encryptData(apiData);
      accessPortal(encryptedPayload);
    } else {
      const uuid = getCookie('uuid');
      const apiData = {
        P_UID: uuid,
      };
      const encryptedPayload = encryptData(apiData);
      accessPortal(encryptedPayload);
    }
  }, []);

  useEffect(() => {
    if (accessPortalData?.P_IS_VALID === 1) {
      const apiData = {
        P_CLIENT_ID: accessPortalData?.P_CLIENT_ID,
        P_ACCESS_KEY: accessPortalData?.P_ACCESS_KEY,
        LANG_CODE: i18n.language.toUpperCase(),
      };
      if (accessPortalData?.P_GOOGLE_ANALYTICS_ID) {
        const changeAnalyticsID = (trackingID) => {
          // Remove the existing Google Analytics script if it already exists
          const existingScript = document.getElementById('google-analytics-script');
          if (existingScript) {
            existingScript.remove();
          }

          // Create a new script element for Google Analytics
          const script = document.createElement('script');
          script.id = 'google-analytics-script';
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingID}`;

          // Append the script to the head of the document
          document.head.appendChild(script);

          // Initialize Google Analytics after the script has loaded
          script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              window.dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', trackingID);
          };
        };

        changeAnalyticsID(accessPortalData?.P_GOOGLE_ANALYTICS_ID);
      }
      const encryptedPayload = encryptData(apiData);
      fetchThemeSettings(encryptedPayload);
    }
  }, [accessPortalData]);

  useEffect(() => {
    if (themeSettingsData) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = themeSettingsData?.P_THEME?.P_FAVICON_URL;

      // Replace the existing favicon with the new one
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }, [themeSettingsData]);
  useEffect(() => {
    if (language && !langParam) {
      if (language !== langParam && langParam) {
        i18n.changeLanguage(langParam);
        setItem('language', langParam);
      } else {
        i18n.changeLanguage(language);
      }
    } else {
      i18n.changeLanguage(langParam);
      setItem('language', langParam);
    }
  }, [language]);
  document.title = t('WCD');
  return (
    <>
      {accessLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <Spin />
        </div>
      ) : (
        <>
          {accessPortalData?.P_IS_VALID === 1 && themeSettingsData?.P_THEME ? (
            <>
              <NavBar />
              <span style={{ minHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
                <Routes>
                  <Route exact path="/collection-day" element={<RubbishCollection />} />
                  <Route exact path="/calendar" element={<WasteCalender />} />
                  <Route exact path="/contactus" element={<ContactUs />} />
                  <Route exact path="/Cookies" element={<CookiesPage />} />
                  <Route exact path="/accessibility" element={<AccessibilityPage />} />
                  <Route exact path="/help" element={<HelpPage />} />
                  <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
                  <Route exact path="*" element={<Error404 />} />
                </Routes>
              </span>
              <Footer />
            </>
          ) : accessPortalData?.P_IS_VALID === 0 ? (
            <AccessDenied accessError={accessError} />
          ) : themeSettingsData?.P_THEME === null ? (
            <AccessDenied accessError={accessError} />
          ) : (
            ''
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = ({ themeSlice, accessData }) => {
  const { loading, themeSettingsData } = themeSlice;
  const { accessLoading, accessError, accessPortalData } = accessData;
  return { loading, themeSettingsData, accessLoading, accessPortalData, accessError };
};

const mapDispatchToProps = { fetchThemeSettings, accessPortal };
export default connect(mapStateToProps, mapDispatchToProps)(RouteEntry);
